import React from "react";
import { NotificationResource } from "../../utils/notifications";

// Categories the server sends, mapped to the mark each one shows. course and
// news are the ones nobody sent by hand -- a course welcome, a feature
// announcement -- so they get the 42courses blob rather than a person.
const CATEGORY_ICONS = {
  reply: "icon-reply",
  mark: "icon-shield",
  cert: "icon-cert",
  badge: "icon-badge",
  course: "icon-blob",
  news: "icon-blob",
};

interface Props {
  notification: NotificationResource;
  // "alert-ic" on the full page, "notif-ic" in the bell dropdown. The two have
  // their own sizing but pick their imagery identically, which is the point of
  // this living in one place.
  baseClass: string;
}

// The symbols themselves are defined once per layout in Notifications/Icons.
const AlertIcon = ({ notification, baseClass }: Props) => {
  // Real artwork beats a drawn icon: the badge the alert is announcing, or the
  // face of whoever caused it.
  const artwork = notification.badge_url || notification.avatar;

  if (artwork) {
    return (
      <span
        className={`${baseClass} ${baseClass}--image ${
          notification.badge_url ? `${baseClass}--badge-art` : ""
        }`}
        style={{ backgroundImage: `url(${artwork})` }}
        aria-hidden="true"
      />
    );
  }

  // Every category has an icon; the bell only shows if the server ever sends a
  // category this build doesn't know about.
  const icon = CATEGORY_ICONS[notification.category] || "icon-bell";

  return (
    <span className={`${baseClass} ${notification.category}`} aria-hidden="true">
      <svg aria-hidden="true">
        <use href={`#${icon}`} />
      </svg>
    </span>
  );
};

export default AlertIcon;
